export default __webpack_public_path__ + "static/media/print_estimate_shanai_4.f1a9e935.svg";